export const REDIRECT_LINK = (
    <>
      <a
        href=""
        onClick={() => {
          localStorage.clear();
          window.location.reload();
        }}
      >
        <span className="link-styling">Please reload now.</span>
      </a>
    </>
  );